import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/cancellation/summary'

const initialState = () => ({
    summary: {
        data: [],
        pagination: {}
    },
    reasons: {
        period: {},
        data: []
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        summary: state => state.summary.data,
        pagination: state => state.summary.pagination,
        reasons: state => state.reasons.data,
        reasonsPeriod: state => state.reasons.period
    },
    actions: {
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listSummary: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listSummary(params)
                const summary = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_SUMMARY, summary)
                return summary
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{periodId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listReasons: async ({commit, dispatch}, data) => {
            try {
                const reasons = await api.listReasons(data)
                commit(mutationTypes.SET_SUMMARY_REASONS, reasons)
                return reasons
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetSummary: ({commit}) => commit(mutationTypes.RESET_SUMMARY),
        resetReasons: ({commit}) => commit(mutationTypes.RESET_SUMMARY_REASONS)
    },
    mutations: {
        [mutationTypes.RESET_SUMMARY]: (state) => state.summary = initialState().summary,
        [mutationTypes.RESET_SUMMARY_REASONS]: (state) => state.reasons = initialState().reasons,
        [mutationTypes.SET_SUMMARY]: (state, data) => state.summary = data,
        [mutationTypes.SET_SUMMARY_REASONS]: (state, data) => {
            state.reasons.period = data.period
            state.reasons.data = data.reasons
        }
    }
}
